import React from 'react'
import { twMerge } from 'tailwind-merge'
import { ExpandIcon } from './icons/expand-icon'

interface ExpandButtonProps {
  isActive?: boolean
  onClick: () => void
  className?: string
}

export const ExpandButton = ({
  onClick,
  isActive,
  className,
}: ExpandButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={twMerge(
        'h-[32px] w-[32px] cursor-pointer transition hover:text-bgSecondary',
        isActive
          ? 'text-bgSecondary hover:text-bgTertiary'
          : 'text-transparent',
        className,
      )}
    >
      <ExpandIcon />
    </button>
  )
}
